import React from "react";
import { Link } from "react-router-dom";

function NavBar() {
  return (
    <>
      <div className='py-2 bg-orange-500 text-white font-semibold'>
          <div className='xl:text-xl 3xl:text-3xl w-full grid grid-cols-1 md:grid-cols-5 xl:h-24'>
              <Button name={"About Us"} route={"/"}/>
              <Button name={"Academics"} route={"/"}/>
              <Button name={"Admissions"} route={"/"}/>
              <Button name={"Campus Life"} route={"/"}/>
              <Button name={"Temoc Talk"} route={"/chat"}/>
          </div>
      </div>
      <div className='bg-emerald-400 h-10'>
      </div>
    </>
  );
}

function Button({name, route}) {
  return (
    <Link to={route}>
     <button className='py-1 w-full text-center h-full mx-auto hover:bg-orange-600 hover:font-bold' type="button">
          {name}
     </button>
    </Link>
  )
}

export default NavBar;